// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7eca6ab","455":"46bb1217","977":"9b5569c9"}[chunkId] + ".chunk.js";
};